import { connect } from 'react-redux';

import { tokenLogin } from '../../../redux/actions/token';

import LoginMask from './loginMask';

const mapDispatchToProps = dispatch => ({
  updateLogin: (loggedIn, tokenId) => {
    dispatch(tokenLogin(loggedIn, tokenId));
  }
});

const mapStateToProps = ({ token }) => ({
  isLoggedIn: token.loggedIn,
  currentTokenId: token.id
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginMask);
